import { useLocation, useNavigate } from 'react-router-dom'
import PageHeader from '../../../components/Layout/Header/PageHeader'

const WelcomeKitInfoPage = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const navMetaData = state?.navMetaData

  const handleBack = () => {
    navigate(-1)
  }
  return (
    <div>
      <PageHeader
        pageTitle={navMetaData?.pageTitle}
        handleOnBack={handleBack}
      />
      <div className="h-[calc(100vh-56px)] overflow-hidden">
        <iframe
          loading="lazy"
          sandbox="allow-scripts allow-same-origin"
          className="h-full w-full overflow-x-hidden"
          src={navMetaData?.pageUrl}
        />
      </div>
    </div>
  )
}

export default WelcomeKitInfoPage
